import i18n from '@/i18n'
import ElementLocale from 'element-ui/lib/locale'

const state = {
  language: localStorage.getItem('language') || 'zh_cn',
  theme: localStorage.getItem('theme') || 'dark', // 新增主题状态
  sidebar: {
    opened: localStorage.getItem('sidebarStatus') ? !!+localStorage.getItem('sidebarStatus') : true,
    withoutAnimation: false
  }
}

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    localStorage.setItem('language', language)
  },
  SET_THEME: (state, theme) => {
    state.theme = theme
    localStorage.setItem('theme', theme)
    // 切换HTML根元素的主题类
    const html = document.documentElement
    html.classList.remove('light-theme', 'dark-theme')
    html.classList.add(`${theme}-theme`)
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      localStorage.setItem('sidebarStatus', 1)
    } else {
      localStorage.setItem('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    localStorage.setItem('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  }
}

const actions = {
  async setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
    i18n.locale = language
    // 加载 Element UI 语言包
    let elementLang
    if (language === 'zh_cn' || language === 'zh_tw') {
      elementLang = (await import('element-ui/lib/locale/lang/zh-CN')).default
    } else {
      elementLang = (await import('element-ui/lib/locale/lang/en')).default
    }
    ElementLocale.use(elementLang)
  },
  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  },
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
